import { Auth } from 'aws-amplify'
import axios from 'axios'
import { IMPERSONATION_BANNER_CLOSED_KEY } from '@/components/ImpersonatingBanner/constants'

export const v1BaseURL = 'https://app.marqii.com/api/v1'
export const v2BaseURL = 'https://app.marqii.com/api/v2'

export const api = axios.create({
  baseURL: v1BaseURL,
  paramsSerializer: {
    indexes: null,
  },
})

api.interceptors.request.use(
  async (config) => {
    const session = await Auth.currentSession()
    const accessToken = session.getAccessToken().getJwtToken()

    if (accessToken && config.headers) {
      config.headers.Authorization = `Bearer ${accessToken}`
    } else {
      await Auth.signOut()
      localStorage.removeItem(IMPERSONATION_BANNER_CLOSED_KEY)
      window.location.assign('/')
    }
    return config
  },
  (error) => Promise.reject(error),
)

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { response } = error
    if (response?.status === 401) {
      await Auth.signOut()
      localStorage.removeItem(IMPERSONATION_BANNER_CLOSED_KEY)
      window.location.assign('/')
      return
    }
    return Promise.reject(error)
  },
)
